// extracted by mini-css-extract-plugin
module.exports = {"CompanySizeStep":"CompanySizeStep_CompanySizeStep__FG3Ld","CompanySizeStep__Info":"CompanySizeStep_CompanySizeStep__Info__qks5t"};